import { useQuery } from 'react-query';

import { versionApi } from 'src/Services/API';

const useFetchApiVersion = () => {
  return useQuery({
    queryKey: ['fetch-api-version'],
    queryFn: async () => {
      return (await versionApi.versionControllerGetVersion()).data;
    },
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });
};

export default useFetchApiVersion;
